import {useEffect, useId, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsCenterApproveStudentModal = (props: { active: boolean, closeHandler: any, pendingId:number, name:string, suggestedPrice:number,onDone:any }) => {
    const [price,setPrice] = useState('');
    const [err,setErr] = useState(false);
    const priceId = useId();
    useEffect(() => {
        const isActive = props.active;
        const _price = props.suggestedPrice;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setPrice(_price.toString());
            setErr(false);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [sendSMS,setSendSMS] = useState(true);
    const saveChanges = () => {
        const _pendingId = props.pendingId;
        const _sendSMS = sendSMS ? '1' : '0';
        const _price = parseInt(price.trim() === '' ? '0' : price.trim());
        if(_price < 1){
            setErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/approve',
            {
                id:_pendingId,
                price:_price,
                sms:_sendSMS,
            },
            true,
            (d: {
                result:string,
                reason:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'ثبت نام دانش آموز در این کلاس تایید شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            ()=>{},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>تایید ثبت‌نام</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={priceId}>هزینه کلاس:</label>
                        <input type="text"
                               className={"form-control" + (err ? ' is-invalid' : '')}
                               id={priceId}
                               value={price}
                               onChange={e=>{
                                   const t = e.currentTarget.value;
                                   setPrice(t);
                                   setErr(false);
                               }}
                        />
                        <span style={{
                            display: 'block',
                            color: '#0a53be',
                            fontSize: 14,
                            padding: '5px 5px'
                        }}>{NumberToPersianLetters(price === '' ? 0 : parseInt(price)) + " تومان"}</span>
                        <div className={"invalid-feedback " + (err ? 'd-block' : 'd-none')}>
                            لطفا یک هزینه صحیح و بیشتر از صفر وارد کنید.
                        </div>
                        <button className={"techaran-checkbox" + (sendSMS ? ' active':'')} onClick={()=>setSendSMS(v=>!v)}>
                            <i><CheckIcon/></i>
                            <span>
                                ارسال پیامک
                                <em>یک پیامک اطلاع‌رسانی به والد ارسال خواهد شد.</em>
                            </span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center" style={{marginTop: 30,gap:10}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>تایید دانش‌آموز</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};